"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _iconModule = _interopRequireDefault(require("../icon/icon.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["title", "box", "sizeClass", "height", "width"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var propTypes = {
  /** To give the icon additional context if needed */
  title: _propTypes["default"].string,
  /** To display the icon in a fixed sized box */
  box: _propTypes["default"].bool
};
var defaultProps = {
  title: null,
  box: false,
  sizeClass: 'small'
};
var StarsRatingSmallDeSelectedIcon = function StarsRatingSmallDeSelectedIcon(_ref) {
  var title = _ref.title,
    box = _ref.box,
    sizeClass = _ref.sizeClass,
    height = _ref.height,
    width = _ref.width,
    props = _objectWithoutProperties(_ref, _excluded);
  var svg = /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({}, props), {}, {
    viewBox: "0 0 70 14",
    width: width ? width : 70,
    height: height ? height : 70,
    fill: "currentcolor",
    "aria-labelledby": title ? 'StarsRatingSmallDeSelectedIconTitle' : undefined,
    "aria-hidden": title ? 'false' : 'true',
    role: "img",
    children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      id: "StarsRatingSmallDeSelectedIconTitle",
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M7 0L9.16312 4.32048L14 5.0133L10.5 8.37633L11.3262 13.125L7 10.883L2.67376 13.125L3.5 8.37633L0 5.0133L4.83688 4.32048L7 0Z M21 0L23.1631 4.32048L28 5.0133L24.5 8.37633L25.3262 13.125L21 10.883L16.6738 13.125L17.5 8.37633L14 5.0133L18.8369 4.32048L21 0Z M35 0L37.1631 4.32048L42 5.0133L38.5 8.37633L39.3262 13.125L35 10.883L30.6738 13.125L31.5 8.37633L28 5.0133L32.8369 4.32048L35 0Z M49 0L51.1631 4.32048L56 5.0133L52.5 8.37633L53.3262 13.125L49 10.883L44.6738 13.125L45.5 8.37633L42 5.0133L46.8369 4.32048L49 0Z M63 0L65.1631 4.32048L70 5.0133L66.5 8.37633L67.3262 13.125L63 10.883L58.6738 13.125L59.5 8.37633L56 5.0133L60.8369 4.32048L63 0Z"
    })]
  }));
  if (box) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _iconModule["default"].box,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _iconModule["default"][sizeClass],
        children: svg
      })
    });
  }
  ;
  return svg;
};
StarsRatingSmallDeSelectedIcon.displayName = 'StarsRatingSmallDeSelectedIcon';
StarsRatingSmallDeSelectedIcon.propTypes = propTypes;
StarsRatingSmallDeSelectedIcon.defaultProps = defaultProps;
var _default = exports["default"] = StarsRatingSmallDeSelectedIcon;